import { useProducts as useCachedProducts, Product } from "../services/tempeFabricationCachedClient";

interface UseProductsResult {
  products: Product[];
  loading: boolean;
  error: Error | null;
  totalItems: number;
  totalPages: number;
  nextPage: string | undefined;
}

/**
 * React hook to fetch products from TempeFabrication API with 24-hour caching
 * @param filter - Optional filter string
 * @param limit - Optional limit for pagination
 * @returns Object containing products, loading state, and error
 */
export const useProducts = (filter?: string, limit?: string): UseProductsResult => {
  // Use the cached client which leverages React Query for 24-hour caching
  const query = useCachedProducts({ filter, limit });

  return {
    products: query.data?.results || [],
    loading: query.isLoading,
    error: query.error,
    totalItems: Number(query.data?.totalItems) || 0,
    totalPages: query.data?.totalPages || 0,
    nextPage: query.data?.exclusiveStartKey,
  };
};

/**
 * React hook to fetch products by category
 * @param category - Product category to filter by
 * @param limit - Optional limit for pagination
 * @returns Object containing products, loading state, and error
 */
export const useProductsByCategory = (category: string, limit?: string): UseProductsResult => {
  return useProducts(`category=${category}`, limit);
};

/**
 * React hook to fetch only available products
 * @param limit - Optional limit for pagination
 * @returns Object containing products, loading state, and error
 */
export const useAvailableProducts = (limit?: string): UseProductsResult => {
  return useProducts("status=AVAILABLE", limit);
};
